<template>
  <div id="add_form" class="modal fade moment-editor-modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="moment-editor-title">
            <span class="moment-editor-title-icon"><i class="fa fa-gift"></i></span>
            <div>
              <h5 class="modal-title">{{ editorTitle }}</h5>
              <p>Tulis pesan dengan format WhatsApp dan periksa hasilnya sebelum menyimpan.</p>
            </div>
          </div>
          <button ref="dismisModal" type="button" class="close" data-dismiss="modal" aria-label="Tutup">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div v-if="isCopy" class="moment-copy-note">
            <i class="fa fa-copy"></i>
            Ini adalah salinan momen. Simpan sebagai Draft untuk meninjau sebelum
            memublikasikan.
          </div>

          <div class="moment-editor-mobile-tabs">
            <button
              type="button"
              class="moment-editor-mobile-tab"
              :class="{ active: tabMessage === 'setup' }"
              @click="settabMessage('setup')"
            >
              <i class="fa fa-pencil"></i>
              Edit Pesan
            </button>
            <button
              type="button"
              class="moment-editor-mobile-tab"
              :class="{ active: tabMessage === 'preview' }"
              @click="settabMessage('preview')"
            >
              <i class="fa fa-comment-o"></i>
              Preview
            </button>
          </div>

          <div class="moment-editor-grid">
            <div class="moment-editor-main" :class="{ 'is-mobile-hidden': tabMessage === 'preview' }">
              <section class="moment-form-card">
                <div class="moment-form-section-head">
                  <div>
                    <strong>Informasi Momen</strong>
                    <span>Pilih lisensi dan tentukan tampilan momen.</span>
                  </div>
                </div>

                <div v-if="hasMomentNameField" class="moment-form-group">
                  <label>Nama Momen</label>
                  <input
                    v-model="formParam.header[momentNameKey]"
                    type="text"
                    class="form-control"
                    placeholder="Contoh: Promo Ulang Tahun"
                  />
                </div>
                <div v-else class="moment-derived-title">
                  <span>Nama tampilan</span>
                  <strong>{{ derivedTitle }}</strong>
                  <!-- <small>
                    Nama di daftar diambil dari baris pertama pesan karena API
                    belum menyediakan field nama momen terpisah.
                  </small> -->
                </div>

                <div class="moment-form-group">
                  <label>
                    Lisensi WhatsApp
                    <span class="text-danger">*</span>
                  </label>
                  <multiselect
                    data-tour-step="formbgret.1"
                    v-model="selectedLicense"
                    id="moment-license-select"
                    label="license_name"
                    track-by="id"
                    :placeholder="'Pilih lisensi WhatsApp'"
                    open-direction="bottom"
                    :custom-label="customLabelLicense"
                    :options="licenseOptions"
                    :multiple="false"
                    :searchable="true"
                    :loading="isLoadingLicense"
                    :internal-search="false"
                    :close-on-select="true"
                    :options-limit="300"
                    :limit="3"
                    :limit-text="limitText"
                    :max-height="600"
                    :show-no-results="true"
                    :hide-selected="true"
                    :show-labels="false"
                    @search-change="asyncFindLicenseSelect"
                  >
                    <template slot="option" slot-scope="{ option }">
                      <span>
                        {{ option.license_name }}
                        <small v-if="option.license_phone_number" class="moment-license-option-phone">
                          {{ option.license_phone_number }}
                        </small>
                      </span>
                    </template>
                    <span slot="noResult">Lisensi tidak ditemukan.</span>
                  </multiselect>
                  <small class="moment-field-hint">
                    Gunakan lisensi WhatsApp yang sudah terhubung dengan Waajo.
                  </small>
                </div>
              </section>

              <section class="moment-form-card">
                <div class="moment-form-section-head">
                  <div>
                    <strong>Isi Pesan</strong>
                    <span>Format WhatsApp akan disimpan sebagai teks pesan.</span>
                  </div>
                  <span class="moment-char-badge" :class="{ 'is-over': hasError }">
                    {{ messageLength }} / {{ maxCount }}
                  </span>
                </div>

                <moment-message-editor
                  v-model="formParam.header.message"
                  :max-count="maxCount"
                  placeholder="Contoh: Selamat ulang tahun, Kak ${first_name}! Semoga sehat dan bahagia selalu. 🎂"
                  @input="handleMessageInput"
                />

                <p v-if="hasError" class="moment-form-error">
                  <i class="fa fa-exclamation-circle"></i>
                  Pesan melebihi batas {{ maxCount }} karakter.
                </p>
                <p v-else-if="formError && !formParam.header.message" class="moment-form-error">
                  <i class="fa fa-exclamation-circle"></i>
                  {{ formError }}
                </p>
              </section>

              <section class="moment-form-card" data-tour-step="formbgret.3">
                <div class="moment-form-section-head moment-attach-head">
                  <div>
                    <strong>Lampiran</strong>
                    <span>Opsional. Kirim gambar atau file bersama pesan.</span>
                  </div>
                  <label class="moment-switch">
                    <input
                      type="checkbox"
                      v-model="formParam.header.is_enable_attach_file"
                      aria-label="Aktifkan lampiran pada pesan"
                      @change="updateMessageTypeCurrent('')"
                    />
                    <span class="moment-switch-track">
                      <span class="moment-switch-thumb"></span>
                    </span>
                  </label>
                </div>

                <div v-if="formParam.header.is_enable_attach_file" class="moment-attach-body">
                  <div class="moment-attach-options">
                    <div class="moment-form-group">
                      <label>Tipe pesan</label>
                      <select
                        v-model="uploadMessageType"
                        class="form-control"
                        @change="updateMessageTypeCurrent(uploadMessageType)"
                      >
                        <option v-for="opt in messageTypeOptionsUpload" :key="opt" :value="opt">
                          {{ opt === "image" ? "Gambar" : "Dokumen" }}
                        </option>
                      </select>
                    </div>
                    <label class="moment-custom-url-toggle">
                      <input
                        type="checkbox"
                        v-model="formParam.header.is_custom_url"
                        aria-label="Gunakan URL file untuk lampiran"
                      />
                      <span>Gunakan URL file</span>
                    </label>
                  </div>

                  <div v-if="formParam.header.is_custom_url" class="moment-form-group">
                    <label>URL Gambar / File</label>
                    <input
                      v-model="formParam.header.image_url"
                      type="text"
                      class="form-control"
                      placeholder="https://..."
                    />
                  </div>

                  <div v-else>
                    <div v-if="!formParam.header.image_url" class="moment-upload-zone">
                      <i class="fa fa-cloud-upload"></i>
                      <strong>Tarik file ke sini atau pilih file</strong>
                      <span>Format: {{ extensions }}</span>
                      <file-upload-bc
                        :add-index="true"
                        :data="objFilesMessageHandler"
                        :post-action="uploadUrl"
                        :multiple="false"
                        :headers="headers"
                        :drop="true"
                        :drop-directory="true"
                        v-model="files"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
                        ref="uploadbc"
                        :maximum="maximumUpload"
                        :extensions="extensions"
                      >
                        <span class="moment-upload-btn">
                          <i class="fa fa-paperclip"></i>
                          Pilih File
                        </span>
                      </file-upload-bc>
                    </div>

                    <ul v-if="files.length" class="moment-upload-list">
                      <li v-for="file in files" :key="file.id">
                        <div class="moment-upload-file">
                          <img v-if="file.thumb" :src="file.thumb" alt="" />
                          <i v-else class="fa fa-file-o"></i>
                          <div>
                            <strong>{{ file.name }}</strong>
                            <span>{{ formatSizes(file.size) }}</span>
                          </div>
                          <span v-if="file.success" class="text-success"><i class="fa fa-check-circle"></i></span>
                          <span v-else-if="file.error" class="text-danger">{{ file.error }}</span>
                          <a href="#" @click.prevent="$refs.uploadbc.remove(file)" title="Hapus file">
                            <i class="fa fa-trash-o"></i>
                          </a>
                        </div>
                        <div v-if="file.active || file.progress !== '0.00'" class="progress moment-upload-progress">
                          <div class="progress-bar bg-success" role="progressbar" :style="{ width: file.progress + '%' }"></div>
                        </div>
                      </li>
                    </ul>

                    <div v-if="formParam.header.image_url" class="moment-attach-preview">
                      <img
                        v-if="formParam.header.message_type == 'image'"
                        :src="safeUrl(formParam.header.image_url)"
                        alt="Lampiran"
                      />
                      <a v-else :href="safeUrl(formParam.header.image_url)" target="_blank" rel="noopener">
                        <i class="fa fa-file-text-o"></i>
                        Lihat file terunggah
                      </a>
                      <button type="button" class="moment-attach-remove" @click="removeAttachment">
                        Hapus lampiran
                      </button>
                    </div>
                  </div>

                  <div class="moment-attach-info">
                    <i class="fa fa-info-circle"></i>
                    Maksimal 10 MB. Format yang didukung mengikuti pengaturan upload existing.
                  </div>
                </div>
              </section>
            </div>

            <div class="moment-preview-panel" :class="{ 'is-mobile-hidden': tabMessage === 'setup' }" data-tour-step="formbgret.4">
              <moment-preview
                :message="formParam.header.message"
                :image-url="formParam.header.image_url"
                :message-type="formParam.header.message_type"
                receiver-name="John Wick"
              />
            </div>
          </div>

          <p v-if="formError" class="moment-form-error moment-form-error-bottom">
            <i class="fa fa-exclamation-circle"></i>
            {{ formError }}
          </p>
        </div>

        <div class="modal-footer moment-editor-actions">
          <button type="button" class="btn moment-editor-btn moment-editor-btn-secondary" :disabled="isSending" @click="requestClose">
            Batal
          </button>
          <div class="moment-editor-actions-right">
            <button type="button" class="btn moment-editor-btn moment-editor-btn-draft" :disabled="isSending" @click="saveForm(0, 1)">
              <i class="fa" :class="isSending ? 'fa-spinner fa-spin' : 'fa-save'"></i>
              Simpan Draft
            </button>
            <button type="button" class="btn moment-editor-btn moment-editor-btn-primary" :disabled="isSending" @click="saveForm(0, 0)">
              <i class="fa" :class="isSending ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
              Publish
            </button>
            <button type="button" class="btn moment-editor-btn moment-editor-btn-ghost" :disabled="isSending" @click="saveForm(1, 0)">
              Publish &amp; Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
    <v-tour name="tourGuideSarForm" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>


<script>
import $modal from "jquery";
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import PreviewMessage from "./preview";
import MomentMessageEditor from "./components/MomentMessageEditor.vue";
import MomentPreview from "./components/MomentPreview.vue";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
import { whatsappPlainText, safeAttachmentUrl } from "@/utils/whatsappMessage";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime,
    PreviewMessage,
    MomentMessageEditor,
    MomentPreview
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      maxCount: 1024,
      remainingCount: 1024,
      hasError: false,
      remainingCountAway: 1024,
      hasErrorAway: false,
      tourId: "sar.modalForm",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      tourSteps: [
        {
          target: '[data-tour-step="formbgret.1"]', // We're using document.querySelector() under the hood
          content: "Pilih lisensi WhatsApp yang akan mengirim pesan Momen Spesial.",
          params: {
            placement: "top"
          }
        },

        {
          target: '[data-tour-step="formbgret.2"]',
          content: "Tulis pesan, gunakan formatting WhatsApp, variabel, dan emoji.",
          params: {
            placement: "top"
          }
        },

        {
          target: '[data-tour-step="formbgret.3"]',
          content: "Tambahkan gambar atau file jika diperlukan.",
          params: {
            placement: "top"
          }
        },
        {
          target: '[data-tour-step="formbgret.4"]',
          content: "Periksa simulasi tampilan pesan sebelum menyimpan.",
          params: {
            placement: "top"
          }
        }
      ],
      interactiveMessageType: [
        // { id: "button", label: "Button" },
        { id: "link", label: "Link/Call" },
        // { id: "list_text", label: "List" }
      ],
      tabMessage: "setup", //setup or preview
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        message_type: ""
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document"],
      uploadMessageType: "image",
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/only-upload-filev2",
      maximumUpload: 1,
      accept: "image/jfif,image/png,image/gif,image/jpeg,image/webp",
      extensions: "jfif, gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      buttonsLoading: false,
      linkParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsParams: {
        columnFilters: {
          button_title: "",
          button_text: "",
          button_response: ""
        },
        page: 1,
        perPage: 500 // perPage
      },
      buttonsRows: [],
      linkRows: [],
      selectedLicense: null,
      licenseOptions: [],
      licenseListParam: {
        id: "",
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoadingLicense: false,
      emojiAttr2: {
        open: false,
        width: "0%",
        height: "0px"
      },
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      templateMessage: [
        "${first_name}",
        "${last_name}",
        "${phone_number}",
        "${email}",
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isSending: false,
      formError: "",
      savedSnapshot: "",
      allowClose: false,
      closeConfirmOpen: false,
      modalElement: null,
      formParam: {
        header: {
          copy: false,
          id: "",
          license_id: "",
          message: "",
          is_enable_attach_file: false,
          is_custom_url: false,
          image_url: "",
          message_type: "text",
        },
      },
      isLoading: false
    };
  },
  watch: {
    selectedLicense: {
      handler: function (val) {
        this.formParam.header.license_id = val && val.id ? val.id : "";
        this.formError = "";
      },
      deep: true
    },
    isShowForm: {
      handler: function (val, oldVal) {
        if (val == true) {
          this.allowClose = false;
          this.closeConfirmOpen = false;
          this.formError = "";
          this.tourDetail();
          this.settabMessage("setup");
          this.selectedLicense = null;
          var that = this;
          setTimeout(function () {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamSRSt.header.id != "" &&
              that.formParamSRSt.header.id != null
            ) {
              if (
                typeof that.formParamSRSt.header.copy != "undefined" &&
                that.formParamSRSt.header.copy == true
              ) {
                that.formParamSRSt.header.id = "";
              }

              // console.log("that.formParamSRSt", that.formParamSRSt);
              that.formParam = that.formParamSRSt;
              if (that.formParam.header.license_id != "") {
                that.asyncFindLicense("", that.formParam.header.license_id);
              }

              if (that.formParam.header.image_url != "") {
                that.formParam.header.is_enable_attach_file = true;
                that.uploadMessageType = that.formParam.header.message_type;
              } else {
                that.uploadMessageType = "image";
              }
            } else {
              that.asyncFindLicense("", "");
              that.formParam = {
                header: {
                  copy: false,
                  id: "",
                  license_id: "",
                  message: "",
                  is_enable_away_message: 0,
                  is_enable_attach_file: false,
                  is_custom_url: false,
                  image_url: "",
                  message_type: "text",

                },
              };
            }
            that.countdown();
            that.$nextTick(function () {
              that.markClean();
            });
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    ...mapGetters(["agentSession"]),
    formParamSRSt() {
      return this.$store.state.birthdayGreetings.formParamSRSt;
    },
    isShowForm() {
      return this.$store.state.birthdayGreetings.isShowForm;
    },
    isCopy() {
      return Boolean(this.formParam.header && this.formParam.header.copy);
    },
    isEditMode() {
      return Boolean(
        this.formParam.header &&
          this.formParam.header.id !== "" &&
          this.formParam.header.id !== null &&
          typeof this.formParam.header.id !== "undefined"
      );
    },
    editorTitle() {
      if (this.isEditMode) return "Edit Momen";
      if (this.isCopy) return "Duplikasi Momen";
      return "Tambah Momen";
    },
    momentNameKey() {
      const header = this.formParam.header || {};
      const keys = ["name", "title", "moment_name"];
      return keys.find(key => Object.prototype.hasOwnProperty.call(header, key)) || "";
    },
    hasMomentNameField() {
      return Boolean(this.momentNameKey);
    },
    derivedTitle() {
      const header = this.formParam.header || {};
      const explicit = header.name || header.title || header.moment_name;
      if (explicit) return explicit;
      const plain = whatsappPlainText(header.message || "");
      const firstLine = plain.split(/\r?\n/)[0].trim();
      return firstLine ? firstLine.slice(0, 90) : "Momen Baru";
    },
    messageLength() {
      return String((this.formParam.header && this.formParam.header.message) || "").length;
    }
  },
  methods: {
    currentSnapshot() {
      const header = this.formParam.header || {};
      return JSON.stringify({
        message: header.message || "",
        license_id: header.license_id || "",
        image_url: header.image_url || "",
        is_enable_attach_file: Boolean(header.is_enable_attach_file),
        is_custom_url: Boolean(header.is_custom_url),
        message_type: header.message_type || "",
        name: header.name || header.title || header.moment_name || ""
      });
    },
    markClean() {
      this.savedSnapshot = this.currentSnapshot();
      this.allowClose = false;
    },
    hasUnsavedChanges() {
      return Boolean(this.savedSnapshot) && this.currentSnapshot() !== this.savedSnapshot;
    },
    handleMessageInput(value) {
      this.formParam.header.message = value;
      this.formError = "";
      this.countdown();
    },
    requestClose() {
      if (this.$refs.dismisModal) {
        this.$refs.dismisModal.click();
      }
    },
    handleModalHide(event) {
      if (this.allowClose) {
        return;
      }
      if (this.isSending) {
        event.preventDefault();
        return;
      }
      if (!this.hasUnsavedChanges()) {
        return;
      }
      if (this.closeConfirmOpen) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      this.closeConfirmOpen = true;
      this.$fire({
        title: "Tutup tanpa menyimpan?",
        text: "Perubahan pada momen ini belum disimpan dan akan hilang.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Tutup",
        cancelButtonText: "Lanjut Mengedit",
        confirmButtonColor: "#d92d20"
      }).then(result => {
        this.closeConfirmOpen = false;
        if (result && (result.isConfirmed || result.value === true)) {
          this.allowClose = true;
          this.$nextTick(() => {
            if (this.$refs.dismisModal) {
              this.$refs.dismisModal.click();
            }
          });
        }
      }).catch(() => {
        this.closeConfirmOpen = false;
      });
    },
    removeAttachment() {
      this.formParam.header.image_url = "";
      this.formParam.header.is_enable_attach_file = false;
      this.files = [];
    },
    validateForm() {
      this.formError = "";
      const header = this.formParam.header || {};
      if (!header.license_id) {
        this.formError = "Pilih lisensi WhatsApp terlebih dahulu.";
        return false;
      }
      if (!String(header.message || "").trim()) {
        this.formError = "Isi pesan momen terlebih dahulu.";
        return false;
      }
      if (String(header.message || "").length > this.maxCount) {
        this.formError = "Pesan melebihi batas " + this.maxCount + " karakter.";
        return false;
      }
      if (header.is_enable_attach_file && !header.image_url) {
        this.formError = "Pilih file atau masukkan URL lampiran terlebih dahulu.";
        return false;
      }
      return true;
    },
    countdown: function () {
      this.remainingCount =
        this.maxCount - String(this.formParam.header.message || "").length;
      this.hasError = this.remainingCount < 0;
    },
    countdownAway: function () {
      this.remainingCountAway =
        this.maxCount - this.formParam.header.message_away.length;
      this.hasErrorAway = this.remainingCountAway < 0;
    },
    tourShow() {
      this.$tours["tourGuideSarForm"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourDetail", params).then(response => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    settabMessage(value) {
      this.tabMessage = value;
    },
    addRow() {
      let newRow = {
        select_variable: "conversation",
        condition: "",
        text: ""
      };
      this.formParam.detail_some.push(newRow);
    },
    removeRow(removeIndex, maxIndex) {
      // console.log("removeIndex", removeIndex, maxIndex);
      if (removeIndex == 0 && maxIndex == 0) {
        return;
      }

      if (removeIndex > -1) {
        // only splice array when item is found
        this.formParam.detail_some.splice(removeIndex, 1); // 2nd parameter means remove one item only
      }
    },

    limitText(count) {
      return `and ${count} other`;
    },
    customLabelLicense({ license_name, license_phone_number }) {
      if (typeof license_name != "undefined") {
        return `${license_name} – ${license_phone_number}`;
      }
    },
    asyncFindLicenseSelect(query) {
      this.isLoadingLicense = true;
      this.licenseListParam.license_name = query;
      this.licenseListParam.id = "";
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          this.licenseOptions = (response && response.data && response.data.data) || [];
        })
        .catch(() => {
          this.licenseOptions = [];
        })
        .finally(() => {
          this.isLoadingLicense = false;
        });
    },
    asyncFindLicense(query, id) {
      this.isLoadingLicense = true;
      this.licenseListParam.license_name = query;
      this.licenseListParam.id = typeof id !== "undefined" && id !== "" ? id : "";
      this.$store
        .dispatch("license/getLicenseList", this.licenseListParam)
        .then(response => {
          this.isLoadingLicense = false;
          this.licenseOptions = (response && response.data && response.data.data) || [];
          if (id !== undefined && id !== "" && this.licenseOptions.length > 0) {
            const match = this.licenseOptions.find(
              license => String(license.id) === String(id)
            );
            this.selectedLicense = match || null;
          }
        })
        .catch(() => {
          this.isLoadingLicense = false;
        });
    },
    clearAllLicense() {
      this.selectedLicense = null;
    },
    addTemplateToMesage(template) {
      this.formParam.header.message += template;
    },
    addTemplateToMesage2(template) {
      this.formParam.header.message_away += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    safeUrl(value) {
      return safeAttachmentUrl(value);
    },
    async savePreview() {
      this.formParam.header.message = await this.remove_tags(
        this.formParam.header.message
      );
      await this.$store.dispatch("birthdayGreetings/actFormParamSRSt", this.formParam);
    },
    async saveForm(isExit = 0, isDraft = 0) {
      if (this.isSending) return;

      if (!this.validateForm()) {
        this.$fire({
          title: "Lengkapi data momen",
          text: this.formError,
          type: "warning",
          timer: 3000
        });
        return;
      }

      this.formParam.header.is_publish = isDraft === 1 ? 0 : 1;
      this.isSending = true;

      const confirmation = await this.$fire({
        title: isDraft === 1 ? "Simpan sebagai Draft?" : "Publikasikan momen ini?",
        text:
          isDraft === 1
            ? "Momen akan disimpan sebagai Draft dan belum dikirim otomatis."
            : "Momen akan dipublikasikan dan mengikuti jadwal pengiriman otomatis.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: isDraft === 1 ? "Simpan Draft" : "Publish",
        cancelButtonText: "Batal",
        confirmButtonColor: "#f39c12"
      });

      if (!confirmation || !(confirmation.isConfirmed || confirmation.value === true)) {
        this.isSending = false;
        return;
      }

      this.formError = "";
      this.emojiToggle(false);
      this.emojiToggle2(false);

      try {
        this.formParam.header.message = this.remove_tags(this.formParam.header.message);
        if (typeof this.formParam.header.network_id !== "undefined") {
          this.formParam.header.network_id = parseInt(this.formParam.header.network_id);
          this.formParam.header.create_datetime = parseInt(this.formParam.header.create_datetime);
          this.formParam.header.update_datetime = parseInt(this.formParam.header.update_datetime);
        }

        const response = await this.$store.dispatch(
          "birthdayGreetings/stored",
          this.formParam
        );

        this.$fire({
          title: "Berhasil",
          text: (response && response.msg) || "Momen berhasil disimpan.",
          type: "success",
          timer: 2500
        });

        const wasNew = this.formParam.header.id === "" || this.formParam.header.id === null;
        if (wasNew) {
          this.formParam = {
            header: {
              copy: false,
              id: "",
              license_id: "",
              message: "",
              is_enable_attach_file: false,
              is_custom_url: false,
              image_url: "",
              message_type: "text"
            }
          };
          this.selectedLicense = null;
          this.files = [];
          this.countdown();
        }

        this.markClean();
        if (this.searchData) this.searchData();

        if (isExit == 1) {
          this.allowClose = true;
          this.$nextTick(() => {
            if (this.$refs.dismisModal) {
              this.$refs.dismisModal.click();
            }
          });
        }
      } catch (error) {
        this.formError = "Momen belum dapat disimpan. Periksa data lalu coba lagi.";
        this.$fire({
          title: "Gagal",
          text: this.formError,
          type: "error",
          timer: 3500
        });
      } finally {
        this.isSending = false;
      }
    },
    remove_tags(html) {
      if (!html) return "";
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.header.message += args.emoji;
      // console.log(args); /* return {...}*/
    },
    emojiToggle2(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr2.open == true) {
          this.emojiAttr2.open = false;
        } else {
          this.emojiAttr2.open = true;
        }
      } else {
        this.emojiAttr2.open = isClosed;
      }

      if (this.emojiAttr2.open == true) {
        this.emojiAttr2.width = "96%";
        this.emojiAttr2.height = "250px";
      } else {
        this.emojiAttr2.width = "0%";
        this.emojiAttr2.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji2(args) {
      this.formParam.header.message_away += args.emoji;
      // console.log(args); /* return {...}*/
    },

    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      if (msgType == "") {
        var that = this;
        setTimeout(function () {
          // console.log(
          //   "that.formParam.header.is_enable_attach_file",
          //   that.formParam.header.is_enable_attach_file
          // );
          if (that.formParam.header.is_enable_attach_file == true) {
            that.formParam.header.message_type = "image";
            that.uploadMessageType = that.formParam.header.message_type;
            // that.formParam.header.is_custom_url = false;
            // console.log("that.uploadMessageTyp",that.uploadMessageType)
          } else {
            that.formParam.header.message_type = "text";
          }
        }, 100);
      } else {
        this.uploadMessageType = msgType;
        this.formParam.header.message_type = msgType;
      }
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => { });
        }
        if (newFile.success && !oldFile.success) {
          this.formParam.header.image_url = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.formParam.header.image_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }

    this.$nextTick(() => {
      this.modalElement = document.getElementById("add_form");
      if (this.modalElement && $modal) {
        $modal(this.modalElement).on("hide.bs.modal", this.handleModalHide);
      }
    });
  },
  beforeDestroy() {
    if (this.modalElement && $modal) {
      $modal(this.modalElement).off("hide.bs.modal", this.handleModalHide);
    }
  },
  name: "buttons-add"
};
</script>

<style scoped>
.moment-editor-modal {
  overflow-y: hidden;
}

.moment-editor-modal .modal-content {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 64px);
  overflow: hidden;
  border: 1px solid #e7edf5;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.2);
}

.moment-editor-modal .modal-header {
  align-items: flex-start;
  padding: 16px 20px;
  border-bottom: 1px solid #eef1f4;
}

.moment-editor-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.moment-editor-title-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 10px;
  font-size: 17px;
}

.moment-editor-title h5 {
  margin: 0 0 2px;
  color: #101828;
  font-size: 18px;
  font-weight: 700;
}

.moment-editor-title p {
  margin: 0;
  color: #667085;
  font-size: 12px;
}

.moment-editor-modal .modal-body {
  overflow-y: auto;
  padding: 16px 20px 20px;
}

.moment-copy-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 13px;
  padding: 10px 12px;
  color: #175cd3;
  background: #eff8ff;
  border: 1px solid #b2ddff;
  border-radius: 9px;
  font-size: 12px;
  line-height: 1.45;
}

.moment-editor-mobile-tabs {
  display: none;
  gap: 6px;
  margin-bottom: 12px;
  padding: 4px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.moment-editor-mobile-tab {
  flex: 1;
  min-height: 36px;
  padding: 0 10px;
  color: #667085;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
}

.moment-editor-mobile-tab.active {
  color: #b36b00;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.moment-editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 16px;
  align-items: start;
}

.moment-editor-main {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}

.moment-form-card {
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 13px;
}

.moment-form-section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.moment-form-section-head strong {
  display: block;
  color: #344054;
  font-size: 14px;
  font-weight: 700;
}

.moment-form-section-head span {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.4;
}

.moment-form-section-head.moment-attach-head {
  align-items: center;
  margin-bottom: 0;
}

.moment-char-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.moment-char-badge.is-over {
  color: #b42318;
  background: #fff5f5;
  border-color: #f5b5b5;
}

.moment-form-group {
  margin-bottom: 12px;
}

.moment-form-group:last-child {
  margin-bottom: 0;
}

.moment-form-group > label {
  display: block;
  margin-bottom: 6px;
  color: #475467;
  font-size: 12px;
  font-weight: 600;
}

.moment-form-group .form-control {
  min-height: 40px;
  color: #344054;
  border-color: #dfe3e8;
  border-radius: 9px;
  font-size: 13px;
}

.moment-field-hint {
  display: block;
  margin-top: 5px;
  color: #98a2b3;
  font-size: 11px;
}

.moment-derived-title {
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px dashed #dfe3e8;
  border-radius: 9px;
}

.moment-derived-title > span {
  display: block;
  color: #98a2b3;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}

.moment-derived-title > strong {
  display: block;
  margin-top: 2px;
  color: #344054;
  font-size: 13px;
}

.moment-derived-title > small {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 10px;
  line-height: 1.4;
}

.moment-editor-modal /deep/ .moment-form-card .multiselect {
  min-height: 40px;
  color: #475467;
  border: 1px solid #dfe3e8;
  border-radius: 9px;
  font-size: 13px;
}

.moment-editor-modal /deep/ .moment-form-card .multiselect__tags {
  min-height: 38px;
  padding: 8px 36px 0 11px;
  background: #ffffff;
  border: 0;
  border-radius: 9px;
}

.moment-editor-modal /deep/ .moment-form-card .multiselect__input,
.moment-editor-modal /deep/ .moment-form-card .multiselect__single {
  font-size: 13px;
}

.moment-editor-modal /deep/ .moment-form-card .multiselect__content-wrapper {
  border: 1px solid #e7edf5;
  border-radius: 10px;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.12);
}

.moment-license-option-phone {
  margin-left: 6px;
  color: #98a2b3;
  font-size: 11px;
}

.moment-form-error {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  margin: 8px 0 0;
  color: #b42318;
  font-size: 12px;
  line-height: 1.45;
}

.moment-form-error-bottom {
  margin-top: 12px;
  padding: 9px 11px;
  background: #fff5f5;
  border: 1px solid #f5b5b5;
  border-radius: 8px;
}

.moment-switch {
  display: inline-flex;
  align-items: center;
  margin: 0;
  cursor: pointer;
}

.moment-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.moment-switch-track {
  position: relative;
  display: inline-flex;
  width: 42px;
  height: 23px;
  padding: 2px;
  background: #d0d5dd;
  border-radius: 999px;
  transition: background 0.18s ease;
}

.moment-switch-thumb {
  width: 19px;
  height: 19px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);
  transition: transform 0.18s ease;
}

.moment-switch input:checked + .moment-switch-track {
  background: #12b76a;
}

.moment-switch input:checked + .moment-switch-track .moment-switch-thumb {
  transform: translateX(19px);
}

.moment-attach-body {
  margin-top: 13px;
  padding-top: 13px;
  border-top: 1px solid #f1f4f8;
}

.moment-attach-options {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.moment-attach-options .moment-form-group {
  flex: 1 1 170px;
  margin-bottom: 12px;
}

.moment-custom-url-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  color: #667085;
  font-size: 12px;
}

.moment-custom-url-toggle input {
  width: 15px;
  height: 15px;
}

.moment-upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 22px 14px;
  text-align: center;
  background: #fbfcfe;
  border: 1px dashed #cfd8e3;
  border-radius: 10px;
}

.moment-upload-zone > i {
  color: #b36b00;
  font-size: 22px;
}

.moment-upload-zone > strong {
  color: #475467;
  font-size: 12px;
}

.moment-upload-zone > span {
  color: #98a2b3;
  font-size: 10px;
  word-break: break-word;
}

.moment-upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  padding: 7px 11px;
  color: #b36b00;
  background: #fffaf0;
  border: 1px solid #f2ce91;
  border-radius: 7px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.moment-upload-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin: 10px 0 0;
  padding: 0;
  list-style: none;
}

.moment-upload-file {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 8px;
}

.moment-upload-file img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 5px;
}

.moment-upload-file > i {
  width: 30px;
  color: #667085;
  font-size: 18px;
  text-align: center;
}

.moment-upload-file > div {
  flex: 1;
  min-width: 0;
}

.moment-upload-file strong {
  display: block;
  overflow: hidden;
  color: #344054;
  font-size: 11px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.moment-upload-file span {
  display: block;
  color: #98a2b3;
  font-size: 10px;
}

.moment-upload-file a {
  color: #98a2b3;
}

.moment-upload-progress {
  height: 4px;
  margin-top: 4px;
}

.moment-attach-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  padding: 9px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 9px;
}

.moment-attach-preview img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 7px;
}

.moment-attach-preview a {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #475467;
  font-size: 12px;
}

.moment-attach-remove {
  margin-left: auto;
  padding: 0;
  color: #b42318;
  background: transparent;
  border: 0;
  font-size: 11px;
  font-weight: 600;
}

.moment-attach-info {
  margin-top: 9px;
  color: #98a2b3;
  font-size: 10px;
  line-height: 1.4;
}

.moment-attach-info i {
  margin-right: 4px;
  color: #2e90fa;
}

.moment-preview-panel {
  position: sticky;
  top: 8px;
  min-width: 0;
}

.moment-editor-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  padding: 13px 20px 17px;
  border-top: 1px solid #eef1f4;
}

.moment-editor-actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.moment-editor-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 38px;
  padding: 0 13px;
  border-radius: 9px;
  font-size: 12px;
  font-weight: 700;
}

.moment-editor-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.moment-editor-btn-secondary {
  color: #475467;
  background: #ffffff;
  border: 1px solid #e7edf5;
}

.moment-editor-btn-secondary:hover {
  color: #b36b00;
  background: #fffaf0;
  border-color: #f2ce91;
}

.moment-editor-btn-draft {
  color: #8a5a00;
  background: #fffaf0;
  border: 1px solid #f2ce91;
}

.moment-editor-btn-draft:hover {
  background: #fff3d9;
}

.moment-editor-btn-primary {
  color: #ffffff;
  background: #f39c12;
  border: 1px solid #f39c12;
}

.moment-editor-btn-primary:hover {
  background: #e08b13;
  border-color: #e08b13;
}

.moment-editor-btn-ghost {
  color: #667085;
  background: transparent;
  border: 1px solid transparent;
}

.moment-editor-btn-ghost:hover {
  color: #b36b00;
  background: #fffaf0;
}

@media (max-width: 991px) {
  .moment-editor-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .moment-editor-mobile-tabs {
    display: flex;
  }

  .is-mobile-hidden {
    display: none !important;
  }

  .moment-preview-panel {
    position: static;
  }
}

@media (max-width: 767px) {
  .moment-editor-modal .modal-dialog {
    min-height: 0;
    max-width: calc(100vw - 16px);
    margin: 8px auto;
  }

  .moment-editor-modal .modal-content {
    max-height: calc(100vh - 32px);
  }

  .moment-editor-modal .modal-body {
    padding: 14px;
  }

  .moment-editor-modal .modal-header {
    padding: 14px;
  }

  .moment-editor-title p {
    display: none;
  }

  .moment-editor-actions {
    align-items: stretch;
    flex-direction: column;
    padding: 12px 14px 16px;
  }

  .moment-editor-actions-right {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .moment-editor-actions-right .moment-editor-btn-ghost {
    grid-column: 1 / -1;
  }

  .moment-editor-btn {
    width: 100%;
  }

  .moment-form-card {
    padding: 12px;
  }

  .moment-attach-options {
    align-items: stretch;
    flex-direction: column;
  }

  .moment-custom-url-toggle {
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/automation/birthdayGreetings/form.vue